/**
 * @interface ICleanup - interface for cleaning up resources holded by class implements this interface
 */
export interface ICleanup {
    /**
     * @method cleanup - cleanup resources holded by class implementing this interface.
     */
    cleanup(): void;
}

export type ErrorFunction = (error: any) => void;

/**
 * @type PromiseRetryOptions - options for @PromiseUtils.retry() method.
 */
export type PromiseRetryOptions = {
    /**
     * @property interval - initial wait time between attempts in milliseconds
     */
    interval: number;

    /**
     * @max_tries - maximum number of attempts to try the operation
     */
    max_tries: number;

    /**
     * @property predicate - promise will be retried only if the predicate expectation is met, it will otherwise fail immediately.
     * @param e - error catched by retry
     */
    predicate?: (e: Error) => boolean;
}

/**
 * @enum ScriptLoadType - types for loading scripts into document head.
 */
export enum ScriptLoadType {
    /**
     * @member Url - script will be loaded into document head by defined url (src)
     */
    Url,

        /**
         * @member Text - script will be loaded into document head by defined JS content
         */
    Content
}

export type UrlInfo = {
    /**
     * @member href - The full URL that was originally parsed. Both the protocol and host are lowercased.
     */
    href: string;

    /**
     * @member protocol - The request protocol, lowercased.
     */
    protocol: string;

    /**
     * @member host - The full lowercased host portion of the URL, including port information.
     */
    host: string;

    /**
     * auth - The authentication information portion of a URL.
     */
    auth: string;

    /**
     * hostname - Just the lowercased hostname portion of the host.
     */
    hostname: string;

    /**
     * port - The port number portion of the host.
     */
    port: string;

    /**
     * pathname - The path section of the URL, that comes after the host and before the query, including the initial slash if present.
     */
    pathname: string;

    /**
     * search - The 'query string' portion of the URL, including the leading question mark.
     */
    search: string;

    /**
     * path - Concatenation of pathname and search.
     */
    path: string;

    /**
     * query - Either the 'params' portion of the query string, or a querystring-parsed object.
     */
    query: string | Object;

    /**
     * hash - The 'fragment' portion of the URL including the pound-sign.
     */
    hash: string;
}

export enum DateFormatType {
    Date,
    Time,
    DateTime
}

export interface IBrowserInfo {
    name: string;
    version: string|number;
    osversion: string|number;
}

export interface IBowserMinVersions {
    // { msie: "11", "firefox": "4" }
    [index: string]: string;
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/CommonTypes.ts
 **/